module.exports = __webpack_public_path__ + "assets/img/03c1719b14cf2a8074c2981ce56bc1e6.svg";